import React, { useState } from "react";
import clsx from "classnames";
import { toast } from "react-hot-toast";
import ReportSuccess from "../components/ReportComponent/ReportSuccess";
import { getServerError } from "../helper/misc";
import management from "../api/management";
import Button from "../components/GeneralComponents/Button";
import { useAuth } from "../helper/auth";
import { useForm } from "react-hook-form";
import { isValidPhoneNumber, isValidString } from "../helper/validators";
import Navbar from "../components/HomeComponents/Navbar";
import { useNavigate } from "react-router-dom";
// unauthenticated user => name, phonenumber, location, message
// authenticated user => location, message

const defaultValues = {
  name: "",
  location: "",
  message: "",
  phone_number: "",
};

function ReportLeakage({ authenticated }) {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({ defaultValues });
  const [step, setStep] = useState(1);
  const [reporting, setReporting] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  const nextStep = () => {
    setStep((step) => step + 1);
  };

  const prevStep = () => {
    navigate("/buy-water");
  };

  const report = async (data) => {
    const { name, phone_number, ...requiredValues } = data;
    setReporting(true);
    let payload = { ...requiredValues };
    if (!auth.user) {
      payload = { ...payload, name, phone_number };
    }
    try {
      await management.reportLeakage(payload);
      setReporting(false);
      nextStep();
    } catch (e) {
      setReporting(false);
      toast.error(getServerError(e));
    }
  };
  return (
    <>
      {!authenticated && <Navbar />}
      {step === 1 ? (
        <div className="bg-[#F3F5F9] min-h-screen lg:!min-w-[600px] max-w-[1000px] lg:mt-[-2rem] border lg:rounded-3xl lg:mx-auto pb-20 lg:scale-[80%]">
          <h2 className="pt-20 font-semibold text-3xl text-center">
            Report Leakage
          </h2>
          <form
            className="flex flex-col pt-16 lg:pt-24 justify-center items-center"
            onSubmit={handleSubmit(report)}
          >
            {!auth.user && (
              <>
                <input
                  required
                  {...register("name", {
                    required: true,
                    validate: (v) => isValidString(v),
                  })}
                  placeholder="Type in your name"
                  className={clsx(
                    "w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border-2 rounded-2xl bg-gray-100 mt-8",
                    { "!outline-[red]": errors.name }
                  )}
                />
                <input
                  required
                  {...register("phone_number", {
                    required: true,
                    validate: (v) => isValidPhoneNumber(v),
                  })}
                  placeholder="Type in your phone number"
                  className={clsx(
                    "w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border-2 rounded-2xl bg-gray-100 mt-8",
                    { "!outline-[red]": errors.phone_number }
                  )}
                />
              </>
            )}
            <input
              required
              {...register("location", {
                required: true,
                validate: (v) => isValidString(v),
              })}
              placeholder="Enter the Location"
              className={clsx(
                "w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border-2 rounded-2xl bg-gray-100 mt-8",
                { "!outline-[red]": errors.location }
              )}
            />
            <textarea
              {...register("message", {
                required: true,
                validate: (v) => isValidString(v),
              })}
              required
              className={clsx(
                "w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border-2 !border-[#E5E7EB] rounded-2xl bg-gray-100 mt-8",
                { "!outline-[red]": errors.message }
              )}
              placeholder="Type in a message"
            ></textarea>
            <Button loading={reporting} text="Report" type="submit" />
          </form>
        </div>
      ) : (
        <ReportSuccess authenticated={authenticated} prevStep={prevStep} />
      )}
    </>
  );
}

export default ReportLeakage;
